module.exports = __webpack_public_path__ + "img/Logo-18.95c0cb4c.svg";